var jlBusinessDirectory = {
  load:function(){
    this.loader = document.getElementById("businessListingsLoading");
    document.getElementById("businessListingsFound").style.display = "none";
    document.getElementById("businessListingsNotFound").style.display = "none";
    document.getElementById("businessList").innerHTML = "";
    this.loader.style.display = "block";
    this.getListings();
  },
  getListings:function(){
    var self = this;
    window.addEventListener("hubHawaiiLogin",function(e){
      self.load();
    });

    if(hh2020Login.userData && hh2020Login.userData.token){
      var formData = new FormData;
      formData.append('id',hh2020Login.userData.id);
      formData.append('token',hh2020Login.userData.token);
      fetch(JLAJAX.directoryURL+"mylistings/",{
        "method":"POST",
        "headers":{
          //"Content-Type":"application/json",
          "Accept":"application/json",
        },
        body:formData
      }).then(res=>res.json())
      .then(data=>{
        self.loader.style.display = "none";
        var listHolder = document.getElementById("businessList");

        data = data.filter(d=>{
          return d.subregion.region.regionslug == JLAJAX.region;
        });

        if(data.length > 0){
          document.getElementById("businessListingsFound").style.display = "block";
          document.getElementById("businessListingsNotFound").style.display = "none";
        }
        else{
          document.getElementById("businessListingsFound").style.display = "none";
          document.getElementById("businessListingsNotFound").style.display = "block";
        }
        for(let listing of data){

          var form = document.createElement("form");
          form.setAttribute("action",JLAJAX.homeURL + "post/2");
          form.setAttribute("method","post");
          form.id = "form"+listing.id;

          var editData = document.createElement("input");
          editData.setAttribute("type","hidden");
          editData.setAttribute("name","editData");
          editData.setAttribute("value",JSON.stringify(
            {
              'businessName':listing.title,
              'address':listing.address,
              'region':listing.subregion.subregionname,
              'website':listing.website,
              'latitude':listing.latitude,
              'longitude':listing.longitude,
              'token':hh2020Login.userData.token,
              'id':hh2020Login.userData.id,
              'businessDirectoryID':listing.id,
              'island':JLAJAX.region
            }
          ));
          form.append(editData);

          var link = document.createElement("a");
          link.setAttribute("data-listingid",listing.id);

          link.addEventListener("click",function(e){
            e.preventDefault();
            jlLoader.show('Gathering Your Business Info');
            document.getElementById("form"+e.currentTarget.getAttribute("data-listingid")).submit();
          });


          link.classList.add("button3");

          var linkHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward Circle</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M262.62 336L342 256l-79.38-80M330.97 256H170"/><path d="M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>';
          linkHTML += '<b>'+listing.title+'</b>';
          linkHTML += listing.address;
          link.innerHTML = linkHTML;

          form.append(link);
          listHolder.append(form);

        }

      });
    }
  }
};
